/* eslint-disable jsx-a11y/media-has-caption */
import React from "react";
import { VideoEditor } from "@culturehq/components";
import { usePostStoryContext } from "../../contexts/PostStoryContext";

const PostStoryVideoPreview = () => {
  const {
    state: {
      selectedMedia,
      videoDimension,
      selectedThumbnailUrl,
      videoDuration
    },
    handleVideoEdited,
    setState
  } = usePostStoryContext();

  const handleDurationChange = (
    { currentTarget: { duration } }: React.SyntheticEvent<HTMLVideoElement>) => {
    if (videoDuration !== duration && duration !== Infinity) {
      setState({ videoDuration: duration });
    }
  };

  const handleLoadedMetadata = (
    { currentTarget: { videoHeight, videoWidth } }: React.SyntheticEvent<HTMLVideoElement>) => {
    if (
      videoDimension.height !== videoHeight
      && videoDimension.width !== videoWidth
    ) {
      setState({
        videoDimension: {
          height: videoHeight,
          width: videoWidth
        }
      });
    }
  };

  if (selectedMedia instanceof Blob) {
    return (
      <>
        <video
          autoPlay
          controls
          muted
          src={URL.createObjectURL(selectedMedia)}
          style={{ position: "absolute", visibility: "hidden" }}
          onDurationChange={handleDurationChange}
          onLoadedMetadata={handleLoadedMetadata}
        />
        {!selectedThumbnailUrl && (
          <VideoEditor
            asButtonView
            onEdit={handleVideoEdited}
            video={URL.createObjectURL(selectedMedia as Blob)}
          />
        )}
      </>
    );
  }
  return null;
};

export default PostStoryVideoPreview;
